import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser"

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID || ""}`,
    // Se usa una página HTML ligera para el redirect del popup.
    // Esto evita cargar toda la aplicación de React en la ventana emergente,
    // lo que soluciona problemas de bloqueos y mejora el rendimiento.
    redirectUri: `${globalThis.location.origin}/auth.html`
  },
  cache: { cacheLocation: "localStorage" },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error("MSAL System Error:", message)
            return
          case LogLevel.Warning:
            console.warn("MSAL System Warning:", message)
            return
          default:
            return
        }
      }
    },
    allowRedirectInIframe: true,
    redirectNavigationTimeout: 120000,
    iframeBridgeTimeout: 60000,
    // 5 minutos para que el usuario complete el flujo de auth sin recibir timed_out prematuramente
    popupBridgeTimeout: 300000
  }
}

// Guardamos la configuración mínima en localStorage por compatibilidad,
// aunque el redirect-bridge actual no la requiere estrictamente.
localStorage.setItem(
  "msal_config_cache",
  JSON.stringify({
    clientId: msalConfig.auth.clientId,
    authority: msalConfig.auth.authority
  })
)

export const pca = new PublicClientApplication(msalConfig)
await pca.initialize()

export const loginRequest = { scopes: ["openid", "profile", "email"] }
